import { render, staticRenderFns } from "./OptionVorlagenproduktdesign.vue?vue&type=template&id=538ef065&"
import script from "./OptionVorlagenproduktdesign.vue?vue&type=script&lang=js&"
export * from "./OptionVorlagenproduktdesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports